import { render, staticRenderFns } from "./SkupBase.vue?vue&type=template&id=58911be8&scoped=true&"
import script from "./SkupBase.vue?vue&type=script&lang=js&"
export * from "./SkupBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58911be8",
  null
  
)

export default component.exports